/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_BC_66_67 as Componente_BC_66_67,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_zC_122_67(e) {
  let t = (0, ReactCompiler.c)(2),
    { cantidad: n } = e,
    r = n === void 0 ? 6 : n,
    i;
  return (
    t[0] === r
      ? (i = t[1])
      : ((i = (
          <div
            className={`grid gap-3 sm:grid-cols-2 lg:grid-cols-3`}
            aria-hidden={`true`}
            children={Array.from(
              {
                length: r,
              },
              Componente_BC_66_67,
            )}
          />
        )),
        (t[0] = r),
        (t[1] = i)),
    i
  );
}
